/**
 * FRONTEND ONLY - Captures errors using PostHog for client-side error tracking.
 *
 * ⚠️ WARNING: This function is ONLY for frontend usage. Do NOT use on the server side.
 *
 * @param error - The error to potentially capture. Can be an Error object, ErrorResponse, or any unknown error type.
 * @description Captures 500 errors and unhandled errors (those without status/statusCode) to PostHog for monitoring.
 */
export const posthogCatcher = (error: unknown) => {
  // Skip PostHog in development and on server-side execution.
  /* v8 ignore start -- compile-time Nuxt environment guard; app tests cover the client branch. */
  if (import.meta.dev || import.meta.server) {
    console.error(error);
    return;
  }
  /* v8 ignore stop */

  // This utility is called from global/plugin error hooks where a Nuxt instance
  // may not be active. tryUseNuxtApp prevents "[nuxt] instance unavailable".
  const nuxtApp = tryUseNuxtApp();
  const posthogFactory = nuxtApp?.$posthog;
  if (!posthogFactory || typeof posthogFactory !== 'function') {
    return;
  }

  if (error instanceof Error) {
    posthogFactory().captureException(error);
  } else {
    posthogFactory().captureException(new Error(JSON.stringify(error)));
  }
};
